import type {Context} from '../types';
import {
  addUniversalBindingsBinding,
  createNewCMSBinding,
  isBoundToCMS,
  getBindingData,
  deleteDynBindProperty,
} from '../utils/legacyBindings';
import {type Expression} from '@packages/systems/wfdl-ast';

const richTextLegacyBindingMigrationData = (
  context: Context
): Expression | false => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  const isRichText = jsonNode.type === 'RichText';
  if (!isRichText) {
    return false;
  }

  const dynInnerHTML = data?.dyn?.bind?.innerHTML;
  if (!dynInnerHTML) {
    return false;
  }
  // Get the slug in Universal Bindings format
  const bindingData = getBindingData(dynInnerHTML);
  if (bindingData === false) {
    return false;
  }

  const isCMsBound = isBoundToCMS(context);
  if (isCMsBound === false) {
    return false;
  }

  const richTextBindingUB = createNewCMSBinding(
    bindingData.type,
    'children',
    bindingData.slug
  );

  if (richTextBindingUB === null) {
    return false;
  }

  return richTextBindingUB;
};

export default (context: Context) => {
  const {jsonNode} = context.node;

  const bindingData = richTextLegacyBindingMigrationData(context);
  const needed = bindingData !== false;

  return {
    needed,
    logData: {
      msg: 'Convert RichText CMS bindings to Universal Bindings',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // This is already handled in the needed check but the type
      // does not get refined by it
      if (bindingData === false) {
        return;
      }

      deleteDynBindProperty(jsonNode, 'innerHTML');

      jsonNode.bind =
        addUniversalBindingsBinding(
          'children',
          bindingData,
          jsonNode.bind || null
        ) || undefined;
    },
  };
};
